export default {
  en: {
    GOODSHAPE_INTERACTION_UPDATED: "GoodShape Interaction was successfully updated",
    ADDITIONAL_INFO_UPDATED: "Additional Info was successfully updated",
    NOTE_ADDED: "Note successfully added",
    NOTE_UPDATED: "Note successfully updated",
    NOTE_DELETED: "Note successfully deleted",
    DOCUMENT_ADDED: "Document was successfully added",
    DOCUMENT_REMOVED: "Document was successfully removed",
    NOTIFICATION_AUDIT: " Notification Audit",
    NOTIFICATION_AUDIT_DUE: "Notification Audit Due",
    NOTIFICATION_AUDIT_DUE_TEXT_LINE1:
      "It is important to ensure that you are set-up to receive the correct notifications. To support with achieving this you are required to complete an audit of your My Employees list.",
    NOTIFICATION_AUDIT_DUE_TEXT_LINE2:
      "To complete the audit you must review the list of employees you are set-up to recieve notifications for and confirm whether they are Correct and Require Removal.",
    NOTIFICATION_AUDIT_DUE_TEXT_IMPORTANT:
      "You will not be able to search for employees until you have reviewed your My Employees list.",
    THANK_YOU_AUDIT_MODAL_TEXT:
      "Thank you for completing the Notification Audit.\nYou can now freely search for employee records.\nA new audit will need to be completed in {numDays} days.",
    IMPORTANT: "IMPORTANT",
    REVIEW_MY_EMPLOYEES: "Review My Employees",
    REMOVAL_CONFIRMATION: "Removal Confirmation",
    CONFIRM_REMOVE_ACCESS:
      "Are you sure you want to remove your access to {name}'s record ?\n\nThis means you can no longer view their absence detials and they will not be included in any of your reports.",
    REMOVE_ACCESS: "Remove Access",
    REQUIRES_REMOVAL: "Requires Removal",
    CONFIRM_AUDIT_COMPLETE: "Confirm Audit Complete",
    ACCIDENT_RELATED: "Accident Related",
    USER_ID: "User ID",
    USER_TYPE: "User Type",
    SEARCH_BY_USERNAME: "Search By Username",
    TOTAL_LOGINS: "Total Logins",
    VIEW_RECORD: "View Record",
    TOTAL_AUTO_CALLBACKS: "Total Auto Callbacks",
    TOTAL_ASAP_CALLBACKS: "Total ASAP Callbacks",
    TOTAL_SCHEDULED_CALLBACKS: "Total Scheduled Callbacks",
    TOTAL_INBOUND_INTERACTIONS: "Total Inbound Interactions",
    CURRENT_STATUS: "Current Status",
    HEADLINES: "Headlines",
    ADMIN: "Admin",
    SERVICE_MANAGER: "Service Manager",
    ABSENCE_ADVISOR: "Absence Advisor",
    CLIENT_ADMIN: "Client admin",
    DUE_DATE: "Due Date",
    DATE_COMPLETED: "Date Completed",
    RESTORE: "Restore",
    FROM_DATE: "From Date",
    TO_DATE: "To Date",

    ABSENCE_REASON_TOOLTIP:
      "Remember that you can smart type in the reason field to find the reason you are after quicker.",
    NOTES: "Notes",
    REASONS: "Reasons",
    SECURITY_ANSWER: "Security Answer",
    SELECT_EMPLOYEE: "Select Employee",
    SET_SHIFT_PATTERN: "Shift Pattern",
    SHIFTS: "Shifts",
    NO_NOTES_MESSAGE: "No notes have been added to this absence.",
    NO_DOCUMENTS_MESSAGE: "No documents have been added to this absence.",
    NO_SMS_MESSAGE: "No SMS messages have been added to this absence.",
    WARNING: "Warning",
    INSTRUCTION: "Instruction",
    SCRIPT: "Script",
    CORRECT: "Correct",
    INCORRECT: "Incorrect",
    ABSENCE_START_DATE: "Absence Start Date",
    INTERACTION_NOTES: "Interaction Notes",
    NO_SHIFT_PATTERNS_FOUND: "No Shift Patterns found.",
    CONTACT_PHONE_NUMBER: "Contact Phone Number",
    REPEAT_SHIFT_PATTERN_DAYS: "{days} Days",
    NOT_PROVIDED_TITLE: "Not Provided {title}",
    REASON_FOR_DECLINE: "Reason for Decline",
    REFERRAL_QUESTIONS_LONG_TEXT:
      "I would like to refer you to our healthcare partner, <strong>{SUPPLIER_NAME}</strong>, who can provide additional, confidential, advice to facilitate your recovery and return to work. Unless you have any objections, I would like to provide them with your contact details so that they can call you directly to discuss how best to support you. Is that ok?",
    MANAGER_REFERRAL_QUESTION_LONG_TEXT:
      "This employee’s absence has met the criteria for a referral to <strong>{SUPPLIER_NAME}</strong> a <strong>{SUPPLIER_DESCRIPTION}</strong> who can provide the employee with advice and support to facilitate their recovery and return to work. Do you wish to refer this employee to <strong>{SUPPLIER_NAME}</strong>?",
    EMERGENCY_INFORMATION: "Emergency Information",
    WHAT_ARE_THE_SYMPTOPMS: "What are the symptoms?",
    HOW_CAN_I_LOOK_AFTER_MYSELF: "How can I look after myself?",
    WHEN_SHOULD_I_WORRY: "When should I worry?",
    WHO_CAN_I_CONTACT: "Who can I contact?",
    TIPS_FOR_WORK: "Tips for work",
    REFERENCES: "References",
    RETURN_TO_WORK_DATE_AND_TIME: "Return to Work Date and Time",
    MESSAGE: "Message",
    OTHER: "Other",
    EXERCISE: "Exercise",
    DELETE_RTW_INTERVIEW_SUCCESS: "Complete RTW Interview deleted.",
    EMPLOYEES_EMPTY_SEARCH_MESSAGE:
      "None of the employee records you have access to match that search criteria. You can only add notification contacts whose record you have permissions to see. Please check that the details you entered are correct.",
    FIT_NOTE_WARNING:
      "<strong>NOTE</strong>: If you’ve received a fit note from the employee, ensure a copy is uploaded on the Documents page.",
    ASSIGN_NEW_LEVEL: "Assign New Level",
    MAINTAIN_CURRENT_STATUS: "Maintain Current Status",
    TEMPRORARILY_DEFER: "Temporarily Defer",
    PLEASE_SELECT_A_REASON: "Please select your reason for no action needing to be taken:",
    APPEAL_UPDATED: "Appeal Details Updated Successfully",
    APPEAL_SUBMITTED: "Appeal Details Submitted Successfully",
    APPEAL_STATUS_NOT_APPEALED_TOOLTIP: "No appeal was logged for this level movement.",
    APPEAL_STATUS_ELIGIBLE_TOOLTIP:
      "No appeal has been logged for this level movement, but the employee is still eligible to do so if they feel they have been unfairly, or incorrectly, treated.",
    APPEAL_STATUS_SUBMITTED_TOOLTIP:
      "The employee has logged an appeal for this level movement, but the hearing has not yet been completed and recorded.",
    APPEAL_STATUS_UPHELD_TOOLTIP:
      "The employee appealed this level movement, but the original decision was <strong>upheld</strong> following a hearing. It's likely that no further action is required and the employee's absence can continue to be managed as normal.",
    APPEAL_STATUS_NOT_UPHELD_TOOLTIP:
      "The employee appealed this level movement, and a subsequent hearing did <strong>not uphold</strong> the original decision. This suggests that the employee was treated unfairly, or incorrectly. Be careful to ensure that any appropriate follow-up tasks and corrective actions were completed.",
    APPEAL_STATUS_CANCELED_TOOLTIP:
      "An appeal was initially logged for this level change but it was later cancelled.",
    APPEAL_RESOLVED: "Appeal Resolved Successfully",
    ENTER_PROCESS: "Enter {firstName} into Absence Monitoring",
    SELECT_ABSENCE_MONITORING_PROCESS: "Select Absence Monitoring process",
    EMPLOYEE_NOT_IN_AM_PROCESS:
      "This employee has never been entered into the Absence monitoring process",
  },
};
